// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAZXV-QeYZutndsmTV6REA09RDz9p3Knp0",
  authDomain: "squarefeetmarble-8d6d4.firebaseapp.com",
  projectId: "squarefeetmarble-8d6d4",
  storageBucket: "squarefeetmarble-8d6d4.firebasestorage.app",
  messagingSenderId: "728293477701",
  appId: "1:728293477701:web:56e088a7dab1c79e4a422c",
  measurementId: "G-QG31PBRLEH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firestore only
export const db = getFirestore(app);
